'use client';
import { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import React from 'react';
import {
   Box,
   Card,
   Flex,
   Input,
   Spinner,
   Table,
   Tbody,
   Td,
   Text,
   Tr,
   useColorModeValue,
   useDisclosure,
   useOutsideClick,
   Thead,
   Th,
   Grid,
   GridItem,
   useColorMode,
} from '@chakra-ui/react';
import Select from 'react-select';
import 'jspdf-autotable';
import nodata from 'assets/img/nfts/no data.svg';
import { Button } from '@chakra-ui/react';
import Download from '../../../../assets/img/nfts/download.svg';
import xls from '../../../../../src/assets/img/nfts/xls.svg';
import back from '../../../../../src/assets/img/nfts/back.svg';
import { Popover, PopoverTrigger, PopoverContent, PopoverBody } from '@chakra-ui/react';
import SalesPurchaseFilter from '../components/SalesPurchaseFilter';
import { useDispatch, useSelector } from 'react-redux';
import { getReportFormat, getAllTransaction } from '../../../../redux/actions/reports';
import { columnsReportsSalesDetail } from '../../customDataTable/variables/columnsData';
import SalesDetails from 'components/salesDetails/SalesDetails';
import { deleteSaleInvoice, getSaleInvoice } from '../../../../redux/actions/salesInvoice';
import { deletePurchaseInvoice, getPurchaseInvoice } from '../../../../redux/actions/purchaseInvoice';
import { getReceiveInventory } from '../../../../redux/actions/receiveInventory';
import { getIssueInventory } from '../../../../redux/actions/issueInventory';
import { getAccountById, getAccount } from '../../../../redux/actions/account';
import { getDaybookForPayments } from '../../../../redux/actions/daybook';
import { deleteRecord } from 'utils/util';
import { useUser } from '../../../../contexts';
import { createColumnHelper, getCoreRowModel, getSortedRowModel, useReactTable } from '@tanstack/react-table';
import { useBusinessType, useGlobal } from '../../../../contexts';
import { SearchIcon } from '@chakra-ui/icons';
import { getShareCompanyOptions } from 'utils/util';
import { renderDynamicDropdown } from 'components/ui/DynamicDropdown';
import { motion } from 'framer-motion';
// import { LuCirclePlus, LuRefreshCcw } from 'react-icons/lu';
import { HiOutlineRefresh } from 'react-icons/hi';
import { transactionType } from 'constants';
import PeriodDatePicker from 'components/RangePicker/PeriodDatePicker';
import { MdCompress, MdExpand } from 'react-icons/md';
import * as XLSX from 'xlsx-js-style';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { IoFilterOutline } from 'react-icons/io5';
import { ChevronDown, ChevronUp } from 'lucide-react';
import ColumnShowHide from '../components/Columnshowhide';
import { getJournalVoucher } from '../../../../redux/actions/journalVoucher';
import { getOneVoucher } from '../../../../redux/actions/voucher';
import {
   getSingleSalesReturnWithPrevAndNext,
   deleteSaleReturnInvoice,
} from '../../../../redux/actions/salesReturnInvoice';
import {
   getSinglePurchaseReturn,
   getSinglePurchaseReturnWithPrevAndNext,
   deletePurchaseReturnInvoice,
} from '../../../../redux/actions/purchaseReturnInvoice';
import JournalVoucherForm from 'views/admin/journal-vouchers/Pages/JournalVoucherForm';
import ViewSingleCashBankData from 'components/UIcomponents/ViewSingleCashBankData';
import PaymentcaseFormEdit from '../../cash/PaymentcaseFormEdit';
import * as Yup from 'yup';
import { deleteRecordForSales } from 'utils/util';
import DeletePasswordModal from 'views/admin/sales/Pages/SalesInvoiceMaster/DeletePasswordModal';

const MotionFlex = motion(Flex);
const MotionSearchIcon = motion(SearchIcon);

const AllTransaction = () => {
   const dispatch = useDispatch();
   const columnHelper = createColumnHelper();
   const { isOpen: isFilterOpen, onOpen: onFilterOpen, onClose: onFilterClose } = useDisclosure();
   const { colorMode } = useColorMode();
   const isDarkMode = colorMode === 'dark';
   const controlBg = useColorModeValue('#FFFFFF', '#2D3748');
   const controlBorder = useColorModeValue('#E2E8F0', '#4A5568');
   const controlBorderHover = useColorModeValue('#CBD5E0', '#718096');
   const focusBoxShadow = useColorModeValue('0 0 0 1px #3182CE', '0 0 0 1px #63B3ED');
   const placeholderColor = useColorModeValue('#A0AEC0', '#718096');
   const optionBg = useColorModeValue('#FFFFFF', '#2D3748');
   const optionHoverBg = useColorModeValue('#EDF2F7', '#4A5568');
   const menuBg = useColorModeValue('#FFFFFF', '#2D3748');
   const menuBorder = useColorModeValue('#E2E8F0', '#4A5568');
   const indicatorColor = useColorModeValue('#718096', '#A0AEC0');
   const indicatorHoverColor = useColorModeValue('#4A5568', '#CBD5E0');
   const textColor = useColorModeValue('secondaryGray.900', 'white');
   const backgroundColor = useColorModeValue('white', '#101F4A');
   const { companyList, company } = useGlobal();
   const [stockTypeSelected, setStockTypeSelected] = useState(transactionType[1]);
   const { businessTypes } = useBusinessType();
   const [companyFilter, setCompanyFilter] = useState([]);
   const dbName = company?.dbName;
   const [searchQuery, setSearchQuery] = useState('');
   const [debouncedSearchQuery, setDebouncedSearchQuery] = React.useState('');
   const [allExpanded, setAllExpanded] = useState(false);
   const bg = useColorModeValue('#f2f7f2', '#1a254b');
   const icon = useColorModeValue('#000000', 'white');
   const [isLoading, setIsLoading] = useState(false);
   const [isFilterLoading, setIsFilterLoading] = useState(false);
   const isFirstRenderFilter = useRef(true);
   const [datePartyWiseSalesRange, setPartyWiseSalesDateRange] = useState({ fromDate: '', toDate: '' });
   const [lastApiCall, setLastApiCall] = useState('');
   const wrapperRef = useRef();
   const [expanded, setExpanded] = useState(false);
   const [entityType, setEntityType] = useState([]);
   const { user } = useUser();
   const admin = user?.isAdmin;
   const rights = user?.userRights?.find((ur) => ur?.companyId === user?.loginhistory?.companyId);
   const companyId = Number(localStorage.getItem('companyId'));
   const userRights = user?.user?.userRights || user?.userRights;
   const cashReceiveRight = Array.isArray(user?.userRights)
      ? user.userRights.find((right) => right.companyId === companyId)?.cashReceive
      : null;

   const cashPaymentRight = Array.isArray(user?.userRights)
      ? user.userRights.find((right) => right.companyId === companyId)?.cashPayment
      : null;

   const bankReceiveRight = Array.isArray(user?.userRights)
      ? user.userRights.find((right) => right.companyId === companyId)?.bankReceive
      : null;

   const bankPaymentRight = Array.isArray(user?.userRights)
      ? user.userRights.find((right) => right.companyId === companyId)?.bankPayment
      : null;
   const saleInvoiceRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.saleinvoice
      : null;
   const saleReturnRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.salereturn
      : null;
   const purchaseInvoiceRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.purchaseinvoice
      : null;
   const purchaseReturnRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.purchasereturn
      : null;

   const IssueRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.inventoryissue
      : null;
   const ReceiveRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.inventoryreceive
      : null;

   const [entityTypesv, setEntityTypesv] = useState([]);
   const [currentRow, setCurrentRow] = useState(null);
   const [isEditMode, setIsEditMode] = useState(true);
   const [isOpenJV, setisOpenJV] = React.useState(null);
   const [isBankPageTrue, setIsBankPageTrue] = React.useState(false);
   const [isOpenSingleViewcnb, setIsOpenSingleViewcnb] = React.useState(null);
   const [isEditFormOpen, setIsEditFormOpen] = React.useState(false);
   const [isOpenSingleViewinr, setIsOpenSingleViewinr] = React.useState(null);
   const [dynamicUserDetails, setDynamicUserDetails] = useState([]);
   const [isEditShowHide, setIsEditShowHide] = useState(false);
   const [editData, setEditData] = useState({});
   const [showHideData, setShowHideData] = useState({});
   const [isShowHideColumn, setIsShowHideColumn] = useState(false);
   const [isOpenPurchaseReturnSingleView, setIsOpenPurchaseReturnSingleView] = React.useState(null);
   const reportformat = useSelector((state) => state.reports?.reportFormat || []);
   const [dataId, setDataId] = useState(null);
   const [isModalOpen, setIsModalOpen] = useState(false);
   const daybookData = useSelector((state) => state.daybook?.list || []);

   // Selectors for different entity types
   const singleEntity = useSelector((state) => {
      if (entityType === 'receiveinventory') {
         return state?.receiveInventory?.single || {};
      } else if (entityType === 'issueinventory') {
         return state?.issueInventory?.single || {};
      } else if (entityType === 'cash') {
         return state.voucher?.single || {};
      } else if (entityType === 'bank') {
         return state.voucher?.single || {};
      } else {
         return {};
      }
   });

   const validationSchema = Yup.object().shape({
      daybookId: Yup.number().required('Daybook is required'),

      accountId: Yup.number()
         .typeError('Account must be a valid')
         .required('Account is required')
         .min(1, 'Account must be greater than 0'),

      amount: Yup.number().required('Amount is required').min(0, 'Amount cannot be negative'),

      docNumber: Yup.string().required('Document number is required'),

      txnDate: Yup.date().required('Transaction date is required').typeError('Invalid transaction date'),

      txnType: Yup.number().required('Transaction type is required'),
   });
   const accountData = useSelector((state) => state.account.list);
   const { userGlobalSettingsData } = useGlobal();
   const shouldSendIdInDaybook = userGlobalSettingsData?.[0]?.askCompany?.daybook || false;
   const shouldSendIdInAccount = userGlobalSettingsData?.[0]?.askCompany?.account || false;
   const daybookTypeData = useSelector((state) => state.daybook?.listPayment || null);
   const [transactionTypem, setTransactionTypem] = useState('payment');
   const [receivedAmount, setReceivedAmount] = useState(0);
   const [totalPendingAccount, setTotalPendingAccount] = useState(0);
   const [updateFormLoading, setUpdateFormLoading] = useState(false);
   const [isOutstandingModalOpen, setIsOutstandingModalOpen] = useState(false);
   const [selectedEditAccount, setSelectedEditAccount] = useState(null);
   const [pendingVoucher, setPendingVoucher] = useState([]);
   const [errors, setErrors] = useState({});
   const [sorting, setSorting] = useState([]);
   const [formData, setFormData] = useState({
      companyId: parseInt(localStorage.getItem('companyId')),
      daybookId: null,
      docNumber: 0,
      txnType: `${transactionTypem === 'payment' ? 1 : 0}`,
      txnDate: new Date().toISOString().split('T')[0],
      accountId: null,
      amount: receivedAmount ? receivedAmount : 0,
      brokerId: null,
      supplierId: null,
      chequeNo: 0,
      transactionNo: null,
      bankId: null,
      bankBranchId: null,
      particulars: '',
      depositeDate: null,
      clearingDate: null,
      tdsApplicable: false,
      tdsAccountId: null,
      tdsLimit: 0,
      tdsRate: 0,
      tdsCess: 0,
      tdsSurcharge: 0,
      tdsAmount: 0,
      tdsCessAmount: 0,
      tdsSurchargeAmount: 0,
      tdsHCessAmount: 0,
      tdsInterestAmount: 0,
      tdsPenaltyAmount: 0,
      tdsOthersAmount: 0,
      notes1: '',
      notes2: '',
      notes3: '',
      notes4: '',
      notes5: '',
      userNote: '',
      taxableValue: '',
      GSTAmount: 0,
      stateOfSupply: 0,
      isRCM: false,
      GSTSubTxnType: 0,
      HSNSACId: null,
      typeofSupply: 0,
      partyBillNo: 0,
      GSTTxnType: 0,
      chequeDate: new Date().toISOString().split('T')[0],
      // pendingAmt: 0,
      outAdjustments: [],
   });

   const account = useSelector((state) => state.account.single);
   const viewDatasi = useSelector((state) => state.sales?.single);
   const viewDatapi = useSelector((state) => state?.purchaseInvoice?.single);
   const viewDatapr = useSelector((state) => state.purchaseReturnInvoice?.purchaseReturnData);
   const viewDatasr = useSelector((state) => state.salesReturnInvoice?.saleReturnData);
   const allTransaction = useSelector((state) => state.reports?.allTransaction || []);
   const IssueSingle = useSelector((state) => state.issueInventory?.single);
   const ReceiveSingle = useSelector((state) => state.receiveInventory?.single);

   const { viewDetail, paginate } = useMemo(() => {
      const data =
         entityType === 'purchasereturn'
            ? viewDatapr?.data[0]
            : entityType === 'salereturn'
               ? viewDatasr?.data[0]
               : entityType === 'saleinvoice'
                  ? viewDatasi
                  : entityType === 'purchaseinvoice'
                     ? viewDatapi
                     : entityType === 'issueinventory'
                        ? IssueSingle
                        : entityType === 'receiveinventory'
                           ? ReceiveSingle
                           : null;
      console.log('IssueSingle', data);

      const pagination =
         entityType === 'purchasereturn'
            ? viewDatapr?.pagination
            : entityType === 'salereturn'
               ? viewDatasr?.pagination
               : entityType === 'saleinvoice'
                  ? viewDatasi?.pagination
                  : entityType === 'purchaseinvoice'
                     ? viewDatapi?.pagination
                     : null;

      return { viewDetail: data, paginate: pagination };
   }, [
      entityType,
      viewDatapr?.data,
      viewDatapr?.pagination,
      viewDatasr?.data,
      viewDatasr?.pagination,
      viewDatasi,
      viewDatapi,
      IssueSingle,
      ReceiveSingle,
   ]);

   const companyIds = useMemo(
      () =>
         companyFilter.length > 0
            ? companyFilter
            : localStorage.getItem('companyId')
               ? [parseInt(localStorage.getItem('companyId'))]
               : [],
      [companyFilter],
   );

   // State for expanded sections
   const [expandedSections, setExpandedSections] = useState({
      transactionTypeSummary: true,
      dailySummary: true,
      salesTransactions: true,
      salesReturnTransactions: true,
      purchasesTransactions: true,
      purchaseReturnTransactions: true,
      issueTransactions: true,
      receiveTransactions: true,
      cashReceiveTransactions: true,
      cashPaymentTransactions: true,
      bankReceiveTransactions: true,
      bankPaymentTransactions: true,
      journalVoucherTransactions: true,
   });

   useOutsideClick({
      ref: wrapperRef,
      handler: () => {
         if (searchQuery === '') setExpanded(false);
      },
   });

   const lastcompanyOptions = useMemo(() => {
      const currentUserCode = user?.loginhistory?.code;
      const currentCompanyId = user?.loginhistory?.companyId;

      // SHARED COMPANY MODE: When code is present
      if (currentUserCode) {
         // Find the company with matching ID AND matching dbName
         const sharedCompany = companyList.find(
            company => company.id === currentCompanyId && company.dbName === currentUserCode
         );

         if (sharedCompany) {
            return [{
               value: sharedCompany.id,
               label: sharedCompany.name,
               id: sharedCompany.id,
               name: sharedCompany.name,
            }];
         }

         // Fallback: try to find by dbName only
         const companiesWithDbName = companyList.filter(company => company.dbName === currentUserCode);
         if (companiesWithDbName.length > 0) {
            return companiesWithDbName.map(company => ({
               value: company.id,
               label: company.name,
               id: company.id,
               name: company.name,
            }));
         }

         return [];
      }

      // NORMAL MODE: When no code, show companies without dbName
      return companyList
         .filter(company => !company.dbName)
         .map(company => ({
            value: company.id,
            label: company.name,
            id: company.id,
            name: company.name,
         }));
   }, [companyList, user?.loginhistory?.code, user?.loginhistory?.companyId]);

   const makeApiCall = useCallback(
      (params) => {
         const apiKey = JSON.stringify(params);

         if (apiKey === lastApiCall) {
            return;
         }

         setLastApiCall(apiKey);
         dispatch(getAllTransaction(params));
      },
      [dispatch, lastApiCall],
   );

   const throttledApiCall = useCallback(
      (() => {
         let lastCall = 0;
         return (params) => {
            const now = Date.now();
            if (now - lastCall >= 300) {
               lastCall = now;
               makeApiCall(params);
            }
         };
      })(),
      [makeApiCall],
   );

   const [columnVisibility, setColumnVisibility] = useState(() =>
      columnsReportsSalesDetail.reduce((acc, column) => {
         acc[column.id] = true;
         return acc;
      }, {}),
   );

   const columns = useMemo(
      () =>
         columnsReportsSalesDetail
            .filter((column) => columnVisibility[column.id])
            .map((column) =>
               columnHelper.accessor(column.id, {
                  id: column.id,
                  header: () => (
                     <Text
                        justifyContent="space-between"
                        align="center"
                        fontSize={{ sm: '10px', lg: '12px' }}
                        color="gray.400">
                        {column.header}
                     </Text>
                  ),
                  cell: (info) => <Flex align="center">{info.getValue()}</Flex>,
               }),
            ),
      [columnHelper, columnVisibility],
   );

   const table = useReactTable({
      data: allTransaction,
      columns,
      getCoreRowModel: getCoreRowModel(),
      getSortedRowModel: getSortedRowModel(),
   });

   useEffect(() => {
      const companyIds =
         companyFilter.length > 0
            ? companyFilter
            : localStorage.getItem('companyId')
               ? [parseInt(localStorage.getItem('companyId'))]
               : [];

      if (
         datePartyWiseSalesRange?.fromDate &&
         datePartyWiseSalesRange?.toDate &&
         companyIds.length > 0 &&
         !companyIds.some((id) => isNaN(id))
      ) {
         const params = {
            companyIds: companyIds.toString(),
            fromDate: datePartyWiseSalesRange.fromDate,
            toDate: datePartyWiseSalesRange.toDate,
            transactionType: stockTypeSelected?.value,
            search: debouncedSearchQuery,
         };

         throttledApiCall(params);
      }
   }, [companyFilter, stockTypeSelected, datePartyWiseSalesRange, debouncedSearchQuery, throttledApiCall]);

   useEffect(() => {
      if (isFirstRenderFilter.current) {
         isFirstRenderFilter.current = false;
         return;
      }
      setIsFilterLoading(false);
   }, [allTransaction]);

   const debounce = (func, delay) => {
      let timer;
      return function (...args) {
         clearTimeout(timer);
         timer = setTimeout(() => func.apply(this, args), delay);
      };
   };
   const debouncedSearchHandler = React.useCallback(
      debounce((query) => {
         setDebouncedSearchQuery(query);
      }, 500),
      [],
   );

   const handleSearchChange = useCallback((e) => {
      const value = e.target.value;
      setSearchQuery(value);
      debouncedSearchHandler(value);
   }, []);

   const handleRefresh = useCallback(() => {
      setIsLoading(true);
      const companyIds =
         companyFilter.length > 0
            ? companyFilter
            : localStorage.getItem('companyId')
               ? [parseInt(localStorage.getItem('companyId'))]
               : [];

      try {
         if (datePartyWiseSalesRange?.fromDate && datePartyWiseSalesRange?.toDate && companyIds.length > 0) {
            const params = {
               companyIds: companyIds.toString(),
               fromDate: datePartyWiseSalesRange.fromDate,
               toDate: datePartyWiseSalesRange.toDate,
               type: stockTypeSelected?.value,
            };
            makeApiCall(params);
         }
      } catch (error) {
         console.error('Refresh error:', error);
      } finally {
         setIsLoading(false);
      }
   }, [companyFilter, datePartyWiseSalesRange, stockTypeSelected, makeApiCall]);

   const handleDateRangeChange = useCallback((dates) => {
      if (!dates || dates.length !== 2) return;

      const [from, to] = dates.map((date) => (typeof date === 'string' ? date : date.toISOString().slice(0, 10)));

      setPartyWiseSalesDateRange({ fromDate: from, toDate: to });
   }, []);

   const handleCompanyChange = useCallback((selectedOptions) => {
      setCompanyFilter(selectedOptions || []);
   }, []);

   useEffect(() => {
      const storedCompanyId = localStorage.getItem('companyId');
      if (storedCompanyId && companyList.length > 0) {
         const companyId = parseInt(storedCompanyId);
         const matchingCompany = companyList.find((comp) => comp.id === companyId);
         if (matchingCompany) {
            setCompanyFilter([matchingCompany.id]);
         }
      }
   }, [companyList]);

   useEffect(() => {
      dispatch(getReportFormat());
   }, [dispatch]);

   useEffect(() => {
      if (businessTypes?.businessType === 'MOBILE') {
         const option = { value: transactionType[0].id, label: transactionType[0].name };
         setStockTypeSelected(option);
      }
   }, [businessTypes]);

   const formatDateToDDMMYYYY = useCallback((dateString) => {
      if (!dateString) return '-';
      try {
         // If it's already in DD-MM-YYYY format, return as is
         if (typeof dateString === 'string' && /^\d{2}-\d{2}-\d{4}$/.test(dateString)) {
            return dateString;
         }

         // Handle ISO string or other date formats
         const date = new Date(dateString);
         if (isNaN(date.getTime())) return '-';

         const day = String(date.getDate()).padStart(2, '0');
         const month = String(date.getMonth() + 1).padStart(2, '0');
         const year = date.getFullYear();

         return `${day}-${month}-${year}`;
      } catch (error) {
         return '-';
      }
   }, []);

   const formatStatusTypeName = useCallback((statusType) => {
      const nameMap = {
         salesTransactions: 'Sales Transaction',
         salesReturnTransactions: 'Sales Return Transaction',
         purchasesTransactions: 'Purchase Transaction',
         purchaseReturnTransactions: 'Purchase Return Transaction',
         receiveTransactions: 'Receive Transaction',
         issueTransactions: 'Issue Transaction',
         cashReceiveTransactions: 'Cash Receive Transaction',
         cashPaymentTransactions: 'Cash Payment Transaction',
         bankReceiveTransactions: 'Bank Receive Transaction',
         bankPaymentTransactions: 'Bank Payment Transaction',
         journalVoucherTransactions: 'Journal Voucher Transaction',
         transactionTypeSummary: 'Transaction Summary',
         dailySummary: 'Daily Summary',
      };
      return nameMap[statusType] || statusType;
   }, []);

   const handleNextPage = () => {
      console.log('Next');
   };
   const handlePrevPage = () => {
      console.log('Prev');
   };

   const expandAll = useCallback(() => {
      setExpandedSections({
         transactionTypeSummary: true,
         dailySummary: true,
         salesTransactions: true,
         salesReturnTransactions: true,
         purchasesTransactions: true,
         purchaseReturnTransactions: true,
         issueTransactions: true,
         receiveTransactions: true,
         cashReceiveTransactions: true,
         cashPaymentTransactions: true,
         bankReceiveTransactions: true,
         bankPaymentTransactions: true,
         journalVoucherTransactions: true,
      });
      setAllExpanded(true);
   }, []);

   const collapseAll = useCallback(() => {
      setExpandedSections({
         transactionTypeSummary: false,
         dailySummary: false,
         salesTransactions: false,
         salesReturnTransactions: false,
         purchasesTransactions: false,
         purchaseReturnTransactions: false,
         issueTransactions: false,
         receiveTransactions: false,
         cashReceiveTransactions: false,
         cashPaymentTransactions: false,
         bankReceiveTransactions: false,
         bankPaymentTransactions: false,
         journalVoucherTransactions: false,
      });
      setAllExpanded(false);
   }, []);
   const allowedDefNames = ['SalesDetailDate', 'SalesDetailParty', 'SalesDetailBroker'];
   const dynamicOptions = reportformat
      .filter((item) => item.defName && allowedDefNames.includes(item.defName))
      .map((item) => ({
         id: item.id,
         value: item.defName && item.title,
         label: item.title,
         isDynamic: true,
         formatData: item,
      }));

   const dynamicOptionValues = dynamicOptions.find((option) => option.value === stockTypeSelected);
   const dynamicEditOption = dynamicOptionValues?.formatData.defName;
   const isStaticReportType = stockTypeSelected;

   const getStockReportColumns = (statusType) => {
      const viewJson = dynamicOptionValues?.formatData?.viewJson || [];

      const convertBackendColor = (backendColor) => {
         if (!backendColor) return null;
         if (backendColor.startsWith('#')) return backendColor;
         if (backendColor.startsWith('0xff')) return '#' + backendColor.substring(4);
         if (/^[0-9A-Fa-f]{6}$/.test(backendColor)) return '#' + backendColor;
         return backendColor;
      };

      const getColumnInfo = (defName) => {
         // First try to find by defName, then by title
         const viewItem = viewJson.find(
            (item) =>
               item?.defName?.toLowerCase() === defName.toLowerCase() ||
               item?.title?.toLowerCase() === defName.toLowerCase(),
         );

         if (!viewItem || isStaticReportType) {
            // Return default values if no customization found or for static report types
            return {
               title: defName,
               isShow: true,
               color: textColor,
               isBold: false,
               isItalic: false,
               orderNo: 0,
               flex: 1,
            };
         }

         return {
            title: viewItem.title || defName,
            isShow: viewItem.isShow === 'true' || viewItem.isShow === true,
            color: viewItem.color ? convertBackendColor(viewItem.color) : textColor,
            isBold: viewItem.isBold === 'true' || viewItem.isBold === true,
            isItalic: viewItem.isItalic === 'true' || viewItem.isItalic === true,
            orderNo: viewItem.orderNo ? parseInt(viewItem.orderNo) : 0,
            flex: viewItem.flex ? parseInt(viewItem.flex) : 1,
         };
      };

      const baseColumns = [];

      if (statusType === 'transactionTypeSummary') {
         baseColumns.push(
            {
               id: 'firstTransaction',
               header: getColumnInfo('First Transaction').title,
               accessor: 'firstTransaction',
               isShow: getColumnInfo('firstTransaction').isShow,
               color: getColumnInfo('firstTransaction').color,
               isBold: getColumnInfo('firstTransaction').isBold,
               isItalic: getColumnInfo('firstTransaction').isItalic,
               orderNo: getColumnInfo('firstTransaction').orderNo,
               flex: getColumnInfo('firstTransaction').flex,
               cell: (info) => formatDateToDDMMYYYY(info.getValue()),
            },
            {
               id: 'lastTransaction',
               header: getColumnInfo('Last Transaction').title,
               accessor: 'lastTransaction',
               isShow: getColumnInfo('lastTransaction').isShow,
               color: getColumnInfo('lastTransaction').color,
               isBold: getColumnInfo('lastTransaction').isBold,
               isItalic: getColumnInfo('lastTransaction').isItalic,
               orderNo: getColumnInfo('lastTransaction').orderNo,
               flex: getColumnInfo('lastTransaction').flex,
               cell: (info) => formatDateToDDMMYYYY(info.getValue()),
            },
            {
               id: 'transactionType',
               header: getColumnInfo('Transaction Type').title,
               accessor: 'transactionType',
               isShow: getColumnInfo('transactionType').isShow,
               color: getColumnInfo('transactionType').color,
               isBold: getColumnInfo('transactionType').isBold,
               isItalic: getColumnInfo('transactionType').isItalic,
               orderNo: getColumnInfo('transactionType').orderNo,
               flex: getColumnInfo('transactionType').flex,
               cell: (info) => info.getValue() || '-',
            },
            {
               id: 'totalAmount',
               header: getColumnInfo('Total Amount').title,
               accessor: 'totalAmount',
               isShow: getColumnInfo('totalAmount').isShow,
               color: getColumnInfo('totalAmount').color,
               isBold: getColumnInfo('totalAmount').isBold,
               isItalic: getColumnInfo('totalAmount').isItalic,
               orderNo: getColumnInfo('totalAmount').orderNo,
               flex: getColumnInfo('totalAmount').flex,
            },
            {
               id: 'totalBalance',
               header: getColumnInfo('Total Balance').title,
               accessor: 'totalBalance',
               isShow: getColumnInfo('totalBalance').isShow,
               color: getColumnInfo('totalBalance').color,
               isBold: getColumnInfo('totalBalance').isBold,
               isItalic: getColumnInfo('totalBalance').isItalic,
               orderNo: getColumnInfo('totalBalance').orderNo,
               flex: getColumnInfo('totalBalance').flex,
            },
            {
               id: 'totalPaid',
               header: getColumnInfo('Total Paid').title,
               accessor: 'totalPaid',
               isShow: getColumnInfo('totalPaid').isShow,
               color: getColumnInfo('totalPaid').color,
               isBold: getColumnInfo('totalPaid').isBold,
               isItalic: getColumnInfo('totalPaid').isItalic,
               orderNo: getColumnInfo('totalPaid').orderNo,
               flex: getColumnInfo('totalPaid').flex,
            },
         );
      } else if (statusType === 'dailySummary') {
         baseColumns.push(
            {
               id: 'date',
               header: getColumnInfo('Date').title,
               accessor: 'date',
               isShow: getColumnInfo('date').isShow,
               color: getColumnInfo('date').color,
               isBold: getColumnInfo('date').isBold,
               isItalic: getColumnInfo('date').isItalic,
               orderNo: getColumnInfo('date').orderNo,
               flex: getColumnInfo('date').flex,
               cell: (info) => formatDateToDDMMYYYY(info.getValue()),
            },
            {
               id: 'count',
               header: getColumnInfo('Count').title,
               accessor: 'count',
               isShow: getColumnInfo('count').isShow,
               color: getColumnInfo('count').color,
               isBold: getColumnInfo('count').isBold,
               isItalic: getColumnInfo('count').isItalic,
               orderNo: getColumnInfo('count').orderNo,
               flex: getColumnInfo('count').flex,
            },
            {
               id: 'transactionType',
               header: getColumnInfo('Transaction Type').title,
               accessor: 'transactionType',
               isShow: getColumnInfo('transactionType').isShow,
               color: getColumnInfo('transactionType').color,
               isBold: getColumnInfo('transactionType').isBold,
               isItalic: getColumnInfo('transactionType').isItalic,
               orderNo: getColumnInfo('transactionType').orderNo,
               flex: getColumnInfo('transactionType').flex,
               cell: (info) => info.getValue() || '-',
            },
            {
               id: 'totalAmount',
               header: getColumnInfo('Total Amount').title,
               accessor: 'totalAmount',
               isShow: getColumnInfo('totalAmount').isShow,
               color: getColumnInfo('totalAmount').color,
               isBold: getColumnInfo('totalAmount').isBold,
               isItalic: getColumnInfo('totalAmount').isItalic,
               orderNo: getColumnInfo('totalAmount').orderNo,
               flex: getColumnInfo('totalAmount').flex,
            },
            {
               id: 'balanceAmount',
               header: getColumnInfo('Balance Amount').title,
               accessor: 'balanceAmount',
               isShow: getColumnInfo('balanceAmount').isShow,
               color: getColumnInfo('balanceAmount').color,
               isBold: getColumnInfo('balanceAmount').isBold,
               isItalic: getColumnInfo('balanceAmount').isItalic,
               orderNo: getColumnInfo('balanceAmount').orderNo,
               flex: getColumnInfo('balanceAmount').flex,
            },

            {
               id: 'paidAmount',
               header: getColumnInfo('Paid Amount').title,
               accessor: 'paidAmount',
               isShow: getColumnInfo('paidAmount').isShow,
               color: getColumnInfo('paidAmount').color,
               isBold: getColumnInfo('paidAmount').isBold,
               isItalic: getColumnInfo('paidAmount').isItalic,
               orderNo: getColumnInfo('paidAmount').orderNo,
               flex: getColumnInfo('paidAmount').flex,
            },
         );
      } else if (
         [
            'journalVoucherTransactions',
            'cashReceiveTransactions',
            'cashPaymentTransactions',
            'bankPaymentTransactions',
            'bankReceiveTransactions',
         ].includes(statusType)
      ) {
         baseColumns.push(
            {
               id: 'docNo',
               header: getColumnInfo('Doc No').title,
               accessor: (row) => {
                  const prefix = row.prefix || row.prifix || '';
                  const postfix = row.postfix || row.postFix || '';
                  const docNo = row.docNo || '';
                  return `${prefix}${docNo}${postfix}`;
               },
               isShow: getColumnInfo('docNo').isShow,
               color: getColumnInfo('docNo').color,
               isBold: getColumnInfo('docNo').isBold,
               isItalic: getColumnInfo('docNo').isItalic,
               orderNo: getColumnInfo('docNo').orderNo,
               flex: getColumnInfo('docNo').flex,
            },
            {
               id: 'transactionDate',
               header: getColumnInfo('Date').title,
               accessor: 'transactionDate',
               isShow: getColumnInfo('transactionDate').isShow,
               color: getColumnInfo('transactionDate').color,
               isBold: getColumnInfo('transactionDate').isBold,
               isItalic: getColumnInfo('transactionDate').isItalic,
               orderNo: getColumnInfo('transactionDate').orderNo,
               flex: getColumnInfo('transactionDate').flex,
               cell: (info) => formatDateToDDMMYYYY(info.getValue()),
            },
            {
               id: 'accountName',
               header: getColumnInfo('Account').title,
               accessor: 'accountName',
               isShow: getColumnInfo('accountName').isShow,
               color: getColumnInfo('accountName').color,
               isBold: getColumnInfo('accountName').isBold,
               isItalic: getColumnInfo('accountName').isItalic,
               orderNo: getColumnInfo('accountName').orderNo,
               flex: getColumnInfo('accountName').flex,
            },
            {
               id: 'daybookName',
               header: getColumnInfo('Daybook').title,
               accessor: 'daybookName',
               isShow: getColumnInfo('daybookName').isShow,
               color: getColumnInfo('daybookName').color,
               isBold: getColumnInfo('daybookName').isBold,
               isItalic: getColumnInfo('daybookName').isItalic,
               orderNo: getColumnInfo('daybookName').orderNo,
               flex: getColumnInfo('daybookName').flex,
            },
            {
               id: 'totalAmount',
               header: getColumnInfo('Total Amount').title,
               accessor: 'totalAmount',
               isShow: getColumnInfo('totalAmount').isShow,
               color: getColumnInfo('totalAmount').color,
               isBold: getColumnInfo('totalAmount').isBold,
               isItalic: getColumnInfo('totalAmount').isItalic,
               orderNo: getColumnInfo('totalAmount').orderNo,
               flex: getColumnInfo('totalAmount').flex,
            },
            {
               id: 'balanceAmount',
               header: getColumnInfo('Balance Amount').title,
               accessor: 'balanceAmount',
               isShow: getColumnInfo('balanceAmount').isShow,
               color: getColumnInfo('balanceAmount').color,
               isBold: getColumnInfo('balanceAmount').isBold,
               isItalic: getColumnInfo('balanceAmount').isItalic,
               orderNo: getColumnInfo('balanceAmount').orderNo,
               flex: getColumnInfo('balanceAmount').flex,
            },
            {
               id: 'paidAmount',
               header: getColumnInfo('Paid Amount').title,
               accessor: 'paidAmount',
               isShow: getColumnInfo('paidAmount').isShow,
               color: getColumnInfo('paidAmount').color,
               isBold: getColumnInfo('paidAmount').isBold,
               isItalic: getColumnInfo('paidAmount').isItalic,
               orderNo: getColumnInfo('paidAmount').orderNo,
               flex: getColumnInfo('paidAmount').flex,
            },
         );
      } else {
         baseColumns.push(
            {
               id: 'docNo',
               header: getColumnInfo('Doc No').title,
               accessor: (row) => {
                  const prefix = row.prefix || row.prifix || '';
                  const postfix = row.postfix || row.postFix || '';
                  const docNo = row.docNo || '';
                  return `${prefix}${docNo}${postfix}`;
               },
               isShow: getColumnInfo('docNo').isShow,
               color: getColumnInfo('docNo').color,
               isBold: getColumnInfo('docNo').isBold,
               isItalic: getColumnInfo('docNo').isItalic,
               orderNo: getColumnInfo('docNo').orderNo,
               flex: getColumnInfo('docNo').flex,
            },
            {
               id: 'transactionDate',
               header: getColumnInfo('Date').title,
               accessor: 'transactionDate',
               isShow: getColumnInfo('transactionDate').isShow,
               color: getColumnInfo('transactionDate').color,
               isBold: getColumnInfo('transactionDate').isBold,
               isItalic: getColumnInfo('transactionDate').isItalic,
               orderNo: getColumnInfo('transactionDate').orderNo,
               flex: getColumnInfo('transactionDate').flex,
               cell: (info) => formatDateToDDMMYYYY(info.getValue()),
            },
            {
               id: 'accountName',
               header: getColumnInfo('Account').title,
               accessor: 'accountName',
               isShow: getColumnInfo('accountName').isShow,
               color: getColumnInfo('accountName').color,
               isBold: getColumnInfo('accountName').isBold,
               isItalic: getColumnInfo('accountName').isItalic,
               orderNo: getColumnInfo('accountName').orderNo,
               flex: getColumnInfo('accountName').flex,
            },
            {
               id: 'daybookName',
               header: getColumnInfo('Daybook').title,
               accessor: 'daybookName',
               isShow: getColumnInfo('daybookName').isShow,
               color: getColumnInfo('daybookName').color,
               isBold: getColumnInfo('daybookName').isBold,
               isItalic: getColumnInfo('daybookName').isItalic,
               orderNo: getColumnInfo('daybookName').orderNo,
               flex: getColumnInfo('daybookName').flex,
            },
            {
               id: 'itemName',
               header: getColumnInfo('Item Name').title,
               accessor: 'itemName',
               isShow: getColumnInfo('itemName').isShow,
               color: getColumnInfo('itemName').color,
               isBold: getColumnInfo('itemName').isBold,
               isItalic: getColumnInfo('itemName').isItalic,
               orderNo: getColumnInfo('itemName').orderNo,
               flex: getColumnInfo('itemName').flex,
            },
            {
               id: 'serialNumbers',
               header: getColumnInfo('Serial No').title,
               accessor: 'serialNumbers',
               isShow: getColumnInfo('serialNumbers').isShow,
               color: getColumnInfo('serialNumbers').color,
               isBold: getColumnInfo('serialNumbers').isBold,
               isItalic: getColumnInfo('serialNumbers').isItalic,
               orderNo: getColumnInfo('serialNumbers').orderNo,
               flex: getColumnInfo('serialNumbers').flex,
            },
            {
               id: 'rate',
               header: getColumnInfo('Rate').title,
               accessor: 'rate',
               isShow: getColumnInfo('rate').isShow,
               color: getColumnInfo('rate').color,
               isBold: getColumnInfo('rate').isBold,
               isItalic: getColumnInfo('rate').isItalic,
               orderNo: getColumnInfo('rate').orderNo,
               flex: getColumnInfo('rate').flex,
            },
            {
               id: 'quantity',
               header: getColumnInfo('Quantity').title,
               accessor: 'quantity',
               isShow: getColumnInfo('quantity').isShow,
               color: getColumnInfo('quantity').color,
               isBold: getColumnInfo('quantity').isBold,
               isItalic: getColumnInfo('quantity').isItalic,
               orderNo: getColumnInfo('quantity').orderNo,
               flex: getColumnInfo('quantity').flex,
            },
            {
               id: 'amount',
               header: getColumnInfo('Amount').title,
               accessor: 'amount',
               isShow: getColumnInfo('amount').isShow,
               color: getColumnInfo('amount').color,
               isBold: getColumnInfo('amount').isBold,
               isItalic: getColumnInfo('amount').isItalic,
               orderNo: getColumnInfo('amount').orderNo,
               flex: getColumnInfo('amount').flex,
            },
            {
               id: 'totalAmount',
               header: getColumnInfo('Total Amount').title,
               accessor: 'totalAmount',
               isShow: getColumnInfo('totalAmount').isShow,
               color: getColumnInfo('totalAmount').color,
               isBold: getColumnInfo('totalAmount').isBold,
               isItalic: getColumnInfo('totalAmount').isItalic,
               orderNo: getColumnInfo('totalAmount').orderNo,
               flex: getColumnInfo('totalAmount').flex,
            },
            {
               id: 'balanceAmount',
               header: getColumnInfo('Balance Amount').title,
               accessor: 'balanceAmount',
               isShow: getColumnInfo('balanceAmount').isShow,
               color: getColumnInfo('balanceAmount').color,
               isBold: getColumnInfo('balanceAmount').isBold,
               isItalic: getColumnInfo('balanceAmount').isItalic,
               orderNo: getColumnInfo('balanceAmount').orderNo,
               flex: getColumnInfo('balanceAmount').flex,
            },
            {
               id: 'paidAmount',
               header: getColumnInfo('Paid Amount').title,
               accessor: 'paidAmount',
               isShow: getColumnInfo('paidAmount').isShow,
               color: getColumnInfo('paidAmount').color,
               isBold: getColumnInfo('paidAmount').isBold,
               isItalic: getColumnInfo('paidAmount').isItalic,
               orderNo: getColumnInfo('paidAmount').orderNo,
               flex: getColumnInfo('paidAmount').flex,
            },
         );
      }

      return baseColumns.filter((col) => col.isShow !== false).sort((a, b) => a.orderNo - b.orderNo);
   };

   const dynamicColumns = useMemo(() => {
      const format = reportformat.find((f) => f.id === stockTypeSelected) || reportformat[0];
      return getStockReportColumns(stockTypeSelected, format);
   }, [stockTypeSelected, reportformat]);

   const columnsData = useMemo(() => {
      return dynamicColumns.map((col, index) => ({
         key: col?.id,
         label: col?.header,
         title: col?.header,
         width: col?.width, // default width if not defined
         index: index + 1,
         status: true,
      }));
   }, [dynamicColumns]);

   const storedCompanyId = localStorage.getItem('companyId');

   const calculateGrandTotals = useCallback(() => {
      if (!allTransaction || allTransaction.length === 0 || companyFilter.length <= 1) {
         return null;
      }

      const grandTotals = {
         totalAmount: 0,
         totalBalance: 0,
         totalPaid: 0,
         transactionCount: 0,
         companyCount: companyFilter.length,
         sectionCounts: {}
      };

      allTransaction.forEach((companyData) => {
         const result = companyData.result || {};

         // Define all possible section types
         const sections = [
            'salesTransactions',
            'salesReturnTransactions',
            'purchasesTransactions',
            'purchaseReturnTransactions',
            'issueTransactions',
            'receiveTransactions',
            'cashReceiveTransactions',
            'cashPaymentTransactions',
            'bankReceiveTransactions',
            'bankPaymentTransactions',
            'journalVoucherTransactions',
            'transactionTypeSummary',
            'dailySummary'
         ];

         sections.forEach((section) => {
            const data = result[section];
            if (data && Array.isArray(data) && data.length > 0) {
               // Initialize section counter if not exists
               if (!grandTotals.sectionCounts[section]) {
                  grandTotals.sectionCounts[section] = 0;
               }
               grandTotals.sectionCounts[section] += data.length;

               data.forEach((item) => {
                  // Count transactions
                  grandTotals.transactionCount++;

                  // Sum up amounts
                  grandTotals.totalAmount += Math.abs(item.totalAmount || 0);
                  grandTotals.totalBalance += Math.abs(item.balanceAmount || 0);
                  grandTotals.totalPaid += Math.abs(item.paidAmount || 0);
               });
            }
         });
      });

      return grandTotals;
   }, [allTransaction, companyFilter]);

   const formatAmount = useCallback((amount) => {
      if (amount === null || amount === undefined) return '0.00';
      const num = parseFloat(amount);
      if (isNaN(num)) return '0.00';
      return num.toLocaleString('en-IN', {
         minimumFractionDigits: 2,
         maximumFractionDigits: 2,
      });
   }, []);

   const GrandTotalHeader = React.memo(({ grandTotals, formatAmount }) => {
      const { colorMode } = useColorMode();
      const isDark = colorMode === 'dark';

      if (!grandTotals) return null;

      return (
         <Box mb={4} className="animate-fadeIn">
            <div className={`
            grid grid-cols-1 md:grid-cols-5 gap-4 p-4 rounded-lg
            ${isDark ? 'bg-gray-800' : 'bg-gradient-to-r from-indigo-50 to-purple-50'}
            border-2 ${isDark ? 'border-indigo-800' : 'border-indigo-200'}
         `}>
               {/* Company Count */}
               <div className="text-center">
                  <p className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Companies</p>
                  <p className={`text-2xl font-bold ${isDark ? 'text-indigo-400' : 'text-indigo-700'}`}>
                     {grandTotals.companyCount}
                  </p>
               </div>

               {/* Transaction Count */}
               <div className="text-center">
                  <p className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Transactions</p>
                  <p className={`text-2xl font-bold ${isDark ? 'text-green-400' : 'text-green-700'}`}>
                     {grandTotals.transactionCount}
                  </p>
               </div>

               {/* Total Amount */}
               <div className="text-center">
                  <p className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Total Amount</p>
                  <p className={`text-xl font-bold ${isDark ? 'text-blue-400' : 'text-blue-700'}`}>
                     ₹ {formatAmount(grandTotals.totalAmount)}
                  </p>
               </div>

               {/* Total Paid */}
               <div className="text-center">
                  <p className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Total Paid</p>
                  <p className={`text-xl font-bold ${isDark ? 'text-teal-400' : 'text-teal-700'}`}>
                     ₹ {formatAmount(grandTotals.totalPaid)}
                  </p>
               </div>

               {/* Total Balance */}
               <div className="text-center">
                  <p className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Total Balance</p>
                  <p className={`text-xl font-bold ${isDark ? 'text-purple-400' : 'text-purple-700'}`}>
                     ₹ {formatAmount(grandTotals.totalBalance)}
                  </p>
               </div>
            </div>
         </Box>
      );
   });

   const MemoizedTableRow = React.memo(
      ({
         item,
         index,
         statusType,
         formatDateToDDMMYYYY,
         setEntityType,
         setIsOpenSingleViewinr,
         setIsOpenPurchaseReturnSingleView,
      }) => {
         const { colorMode } = useColorMode();
         const isDark = colorMode === 'dark';

         const columns = getStockReportColumns(statusType);

         const handledata = async (data) => {
            const companyId = parseInt(storedCompanyId);
            // if (statusType === 'receiveTransactions') {
            //    setEntityType('receivemaster');
            //    const response = await dispatch(getReceiveInventory(data.transactionId));
            //    await dispatch(getAccountById({ id: response?.accountId, compId: user?.loginhistory?.companyId }));
            //    setIsOpenSingleViewinr(true);
            // }
            // if (statusType === 'issueTransactions') {
            //    setEntityType('issuemaster');
            //    const response = await dispatch(getIssueInventory(data.transactionId));
            //    await dispatch(getAccountById({ id: response?.accountId, compId: user?.loginhistory?.companyId }));
            //    setIsOpenSingleViewinr(true);
            // }
            if (statusType === 'purchasesTransactions' && (admin || rights?.purchaseinvoice?.view)) {
               setEntityType('purchaseinvoice');
               await dispatch(getPurchaseInvoice(data.transactionId));
               setIsOpenPurchaseReturnSingleView(true);
            }
            if (statusType === 'salesTransactions' && (admin || rights?.saleinvoice?.view)) {
               setEntityType('saleinvoice');
               await dispatch(getSaleInvoice(data.transactionId));
               setIsOpenPurchaseReturnSingleView(true);
            }
            if (statusType === 'purchaseReturnTransactions' && (admin || rights?.purchasereturn?.view)) {
               setEntityType('purchasereturn');
               await dispatch(getSinglePurchaseReturn(data.transactionId));
               await dispatch(
                  getSinglePurchaseReturnWithPrevAndNext({
                     id: data.transactionId,
                     page: 1,
                     limit: 1,
                     sortBy: 'id',
                     sortOrder: 'desc',
                  }),
               );

               setIsOpenPurchaseReturnSingleView(true);
            }
            if (statusType === 'salesReturnTransactions' && (admin || rights?.salereturn?.view)) {
               setEntityType('salereturn');
               await dispatch(
                  getSingleSalesReturnWithPrevAndNext({
                     id: data.transactionId,
                     page: 1,
                     limit: 1,
                     sortBy: 'id',
                     sortOrder: 'desc',
                  }),
               );
               setIsOpenPurchaseReturnSingleView(true);
            }
            if (statusType === 'issueTransactions' && (admin || rights?.inventoryissue?.view)) {
               setEntityType('issueinventory');
               await dispatch(getIssueInventory(data.transactionId));
               setIsOpenPurchaseReturnSingleView(true);
            }
            if (statusType === 'receiveTransactions' && (admin || rights?.inventoryreceive?.view)) {
               setEntityType('receiveinventory');
               await dispatch(getReceiveInventory(data.transactionId));
               setIsOpenPurchaseReturnSingleView(true);
            }
            if ((statusType === 'cashReceiveTransactions' || statusType === 'cashPaymentTransactions') && (admin || rights?.cashReceive?.view || rights?.cashPayment?.view)) {
               setEntityType('cash');
               setIsBankPageTrue(false);
               await dispatch(getOneVoucher(data.transactionId));
               setIsOpenSingleViewcnb(true);
            }
            if ((statusType === 'bankReceiveTransactions' || statusType === 'bankPaymentTransactions') && (admin || rights?.bankReceive?.view || rights?.bankPayment?.view)) {
               setEntityType('bank');
               setIsBankPageTrue(true);
               await dispatch(getOneVoucher(data.transactionId));
               setIsOpenSingleViewcnb(true);
            }
            if (statusType === 'journalVoucherTransactions' && (admin || rights?.journalvouchers?.view)) {
               setEntityTypesv('JV');
               const response = await dispatch(
                  getJournalVoucher({ docNumber: data.docNo, companyId: user?.loginhistory?.companyId }),
               );
               setCurrentRow(response[0]);
               setisOpenJV(true);
               setIsEditMode(true);
            }
         };

         return (
            <>
               {item?.items && item?.items.length > 0 ? (
                  item.items.map((data, idx) => (
                     <tr
                        key={`${item.id}-${idx}`}
                        onClick={() => handledata(item)}
                        className={`
                        cursor-pointer transition-colors
                        ${isDark ? 'hover:bg-gray-800 border-gray-700' : 'hover:bg-blue-50 border-gray-200'}
                        ${index % 2 === 0 ? (isDark ? 'bg-gray-900' : 'bg-white') : isDark ? 'bg-gray-800/50' : 'bg-gray-50'}
                        border-b
                     `}>
                        {columns.map((column) => (
                           <td
                              key={column.id}
                              className={`px-4 py-3 text-sm ${isDark ? 'text-gray-100' : 'text-gray-800'}`}
                              style={{ flex: column.flex }}>
                              {column.id === 'docNo' ? (
                                 column.accessor(item)
                              ) : ['itemName', 'rate', 'quantity', 'amount', 'serialNumbers'].includes(column.accessor)
                                 ? column.accessor === 'serialNumbers'
                                    ? data[column.accessor]?.map((sn, index) => (
                                       <span key={index}>
                                          {sn}
                                          {index !== data[column.accessor].length - 1 ? ', ' : ''}
                                       </span>
                                    ))
                                    : data[column.accessor]
                                 : idx === 0
                                    ? column.cell
                                       ? column.cell({ getValue: () => item[column.accessor] })
                                       : item[column.accessor]
                                    : ''}
                           </td>
                        ))}
                     </tr>
                  ))
               ) : (
                  <tr
                     onClick={() => handledata(item)}
                     className={`
                     cursor-pointer transition-colors
                     ${isDark ? 'hover:bg-gray-800 border-gray-700' : 'hover:bg-blue-50 border-gray-200'}
                     ${index % 2 === 0 ? (isDark ? 'bg-gray-900' : 'bg-white') : isDark ? 'bg-gray-800/50' : 'bg-gray-50'}
                     border-b
                  `}>
                     {columns.map((column) => (
                        <td
                           key={column.id}
                           className={`px-4 py-3 text-sm ${isDark ? 'text-gray-100' : 'text-gray-800'}`}
                           style={{ flex: column.flex }}>
                           {column.id === 'docNo' ? (
                              column.accessor(item)
                           ) : column.cell ? (
                              column.cell({ getValue: () => item[column.accessor] })
                           ) : (
                              item[column.accessor]
                           )}
                        </td>
                     ))}
                  </tr>
               )}
            </>
         );
      },
   );

   const MemoizedStatusSection = React.memo(
      ({
         statusType,
         data,
         formatStatusTypeName,
         isExpanded,
         onToggleExpand,
         setEntityType,
         setIsOpenSingleViewinr,
         setIsOpenPurchaseReturnSingleView,
      }) => {
         const { colorMode } = useColorMode();
         const isDark = colorMode === 'dark';

         const columns = useMemo(() => getStockReportColumns(statusType), [statusType]);

         const totalAmount = data.reduce((sum, row) => sum + Math.abs(row.totalAmount || 0), 0).toLocaleString('en-IN');
         const totalpaidAmount = data
            .reduce((sum, row) => sum + Math.abs(row.paidAmount || 0), 0)
            .toLocaleString('en-IN');
         const totalbalanceAmount = data
            .reduce((sum, row) => sum + Math.abs(row.balanceAmount || 0), 0)
            .toLocaleString('en-IN');

         // const getGridTemplate = () => {
         //    if (statusType === 'transactionTypeSummary') return 'grid-cols-[3.5fr_1fr_1fr_1fr_auto]';
         //    if (statusType === 'dailySummary') return 'grid-cols-[2fr_1fr_1fr_1fr_auto]';
         //    return 'grid-cols-[9fr_1fr_1fr_1fr_auto]';
         // };

         return (
            <div className="mb-3 overflow-hidden  shadow-lg">
               {/* Header */}
               <div
                  onClick={() => onToggleExpand(statusType)}
                  className={`
            cursor-pointer
            ${isDark ? 'bg-gray-800 border-l-4 border-blue-500' : 'bg-white border-l-4 border-blue-600'}
          `}>
                  <div className={`grid grid-cols-[1fr_auto_auto_auto_auto] items-center gap-4 px-6 py-1`}>
                     {/* Title + Count — left side, takes remaining space */}
                     <div className="flex items-center gap-3">
                        <h2 className={`text-lg font-bold ${isDark ? 'text-white' : 'text-gray-800'}`}>
                           {formatStatusTypeName(statusType)}
                        </h2>
                        <div
                           className={`text-center whitespace-nowrap py-1 px-3 rounded-lg ${isDark ? 'bg-gray-700' : 'bg-green-50'}`}>
                           <p className={`text-xs font-semibold ${isDark ? 'text-green-400' : 'text-green-700'}`}>
                              Total Count -
                              <span className={`text-base ml-2 font-bold ${isDark ? 'text-white' : 'text-gray-900'}`}>
                                 {data?.length > 0 ? data?.length : ''}
                              </span>
                           </p>
                        </div>
                     </div>

                     {/* Total Amount — fixed width, always aligned */}
                     <div
                        className={`text-center whitespace-nowrap py-2 px-3 rounded-lg min-w-[160px] ${isDark ? 'bg-gray-700' : 'bg-green-50'}`}>
                        <p className={`text-xs font-semibold ${isDark ? 'text-green-400' : 'text-green-700'}`}>
                           Total -
                           <span className={`text-base ml-2 font-bold ${isDark ? 'text-white' : 'text-gray-900'}`}>
                              ₹ {totalAmount}
                           </span>
                        </p>
                     </div>

                     {/* Paid Amount */}
                     <div
                        className={`text-center whitespace-nowrap py-2 px-3 rounded-lg min-w-[140px] ${isDark ? 'bg-gray-700' : 'bg-blue-50'}`}>
                        <p className={`text-xs font-semibold ${isDark ? 'text-blue-400' : 'text-blue-700'}`}>
                           Paid -
                           <span className={`text-base ml-2 font-bold ${isDark ? 'text-white' : 'text-gray-900'}`}>
                              ₹ {totalpaidAmount}
                           </span>
                        </p>
                     </div>

                     {/* Balance Amount */}
                     <div
                        className={`text-center whitespace-nowrap py-2 px-3 rounded-lg min-w-[160px] ${isDark ? 'bg-gray-700' : 'bg-orange-50'}`}>
                        <p className={`text-xs font-semibold ${isDark ? 'text-orange-400' : 'text-orange-700'}`}>
                           Balance -
                           <span className={`text-base ml-2 font-bold ${isDark ? 'text-white' : 'text-gray-900'}`}>
                              ₹ {totalbalanceAmount}
                           </span>
                        </p>
                     </div>

                     {/* Toggle Button */}
                     <div
                        className={`flex items-center justify-center w-10 h-10 rounded-lg ${isDark ? 'bg-gray-700' : 'bg-gray-100'}`}>
                        {isExpanded ? (
                           <ChevronUp className={`w-5 h-5 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} />
                        ) : (
                           <ChevronDown className={`w-5 h-5 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} />
                        )}
                     </div>
                  </div>
               </div>

               {/* Table */}
               {isExpanded && (
                  <div className={`${isDark ? 'bg-gray-900' : 'bg-white'}`}>
                     <table className="w-full">
                        <thead>
                           <tr
                              className={`${isDark
                                 ? 'bg-gray-800 border-b border-gray-700'
                                 : 'bg-gray-100 border-b border-gray-300'
                                 }`}>
                              {columns.map((column) => (
                                 <th
                                    key={column.id}
                                    className={`px-4 py-3 text-left text-xs font-bold uppercase ${isDark ? 'text-gray-300' : 'text-gray-700'
                                       }`}
                                    style={{ flex: column.flex }}>
                                    {column.header}
                                 </th>
                              ))}
                           </tr>
                        </thead>
                        <tbody>
                           {data.map((item, index) => (
                              <MemoizedTableRow
                                 key={`${statusType}-${index}`}
                                 item={item}
                                 index={index + 1}
                                 statusType={statusType}
                                 formatDateToDDMMYYYY={formatDateToDDMMYYYY}
                                 setEntityType={setEntityType}
                                 setIsOpenSingleViewinr={setIsOpenSingleViewinr}
                                 setIsOpenPurchaseReturnSingleView={setIsOpenPurchaseReturnSingleView}
                              />
                           ))}
                        </tbody>
                     </table>
                  </div>
               )}
            </div>
         );
      },
   );

   const toggleSection = useCallback((section) => {
      setExpandedSections((prev) => ({
         ...prev,
         [section]: !prev[section],
      }));
   }, []);

   const exportToExcel = () => {
      if (!allTransaction || allTransaction.length === 0) {
         alert('No data to export');
         return;
      }

      // Create a new workbook
      const wb = XLSX.utils.book_new();

      // Define styles
      const styles = {
         header: {
            fill: { fgColor: { rgb: 'F5F5F5' } },
            font: { bold: true, color: { rgb: '000000' } },
            alignment: { horizontal: 'center' },
            border: {
               top: { style: 'thin', color: { rgb: '000000' } },
               bottom: { style: 'thin', color: { rgb: '000000' } },
               left: { style: 'thin', color: { rgb: '000000' } },
               right: { style: 'thin', color: { rgb: '000000' } },
            },
         },
         title: {
            fill: { fgColor: { rgb: 'E6E6E6' } },
            font: { bold: true, size: 14, color: { rgb: '000000' } },
            alignment: { horizontal: 'center' },
         },
         subtitle: {
            fill: { fgColor: { rgb: 'EDEDED' } },
            font: { bold: true, color: { rgb: '000000' } },
            alignment: { horizontal: 'center' },
         },
         cell: {
            border: {
               top: { style: 'thin', color: { rgb: 'DDDDDD' } },
               bottom: { style: 'thin', color: { rgb: 'DDDDDD' } },
               left: { style: 'thin', color: { rgb: 'DDDDDD' } },
               right: { style: 'thin', color: { rgb: 'DDDDDD' } },
            },
         },
         evenRow: {
            fill: { fgColor: { rgb: 'EFF6FF' } },
         },
      };

      allTransaction.forEach((companyData) => {
         const allData = [];
         let maxColumns = 0;

         // Add company title
         allData.push([companyData.companyName]);
         allData.push([]); // Empty row

         Object.keys(companyData.result).map((key) => {
            if (key === 'companyId' || key === 'dateRange' || key === 'summary') return;

            const statusType = key;
            const data = companyData.result[statusType];
            if (!data || data.length === 0) return;

            // Add section title
            allData.push([formatStatusTypeName(statusType)]);
            allData.push([]); // Empty row

            // Determine headers
            let headers;
            if (statusType === 'transactionTypeSummary') {
               headers = [
                  'First Transaction',
                  'Last Transaction',
                  'Total Account',
                  'Balance Amount',
                  'Paid Amount',
                  'Transaction Type',
               ];
            } else if (statusType === 'dailySummary') {
               headers = ['Date', 'Count', 'Total Account', 'Balance Amount', 'Paid Amount', 'Transaction Type'];
            } else {
               headers = ['Doc No', 'Date', 'Account', 'Daybook', 'Total Account', 'Balance Amount', 'Paid Amount'];
            }

            maxColumns = Math.max(maxColumns, headers.length);
            allData.push(headers);

            // Add data rows
            data?.map((item, index) => {
               const row = [];
               if (statusType === 'transactionTypeSummary') {
                  row.push(
                     formatDateToDDMMYYYY(item.firstTransaction),
                     formatDateToDDMMYYYY(item.lastTransaction),
                     item.totalAmount,
                     item.totalBalance,
                     item.totalPaid,
                     item.transactionType,
                  );
               } else if (statusType === 'dailySummary') {
                  row.push(
                     formatDateToDDMMYYYY(item.date),
                     item.count,
                     item.totalAmount,
                     item.balanceAmount,
                     item.paidAmount,
                     item.transactionType,
                  );
               } else {
                  row.push(
                     `${item.prifix || ''}${item.docNo || ''}${item.postFix || ''}`,
                     formatDateToDDMMYYYY(item.transactionDate),
                     item.accountName,
                     item.daybookName,
                     item.totalAmount,
                     item.balanceAmount,
                     item.paidAmount,
                  );
               }
               allData.push(row);
            });

            allData.push([]); // Empty row between sections
         });

         // Remove last empty row if exists
         if (allData.length > 0 && allData[allData.length - 1].length === 0) {
            allData.pop();
         }

         // Create worksheet
         const ws = XLSX.utils.aoa_to_sheet(allData);

         // Apply styles
         const range = XLSX.utils.decode_range(ws['!ref']);
         for (let R = range.s.r; R <= range.e.r; ++R) {
            for (let C = range.s.c; C <= range.e.c; ++C) {
               const cellAddress = { c: C, r: R };
               const cellRef = XLSX.utils.encode_cell(cellAddress);

               if (!ws[cellRef]) continue;

               // Company title
               if (R === 0) {
                  ws[cellRef].s = styles.title;
               }
               // Section titles
               else if (
                  allData[R] &&
                  allData[R].length === 1 &&
                  (allData[R][0] === formatStatusTypeName('onlyReceived') ||
                     allData[R][0] === formatStatusTypeName('partyIssued') ||
                     allData[R][0] === formatStatusTypeName('storeIssued'))
               ) {
                  ws[cellRef].s = styles.subtitle;
               }
               // Headers
               else if (allData[R] && allData[R][0] === 'Doc No') {
                  ws[cellRef].s = styles.header;
               }
               // Data rows
               else {
                  ws[cellRef].s = styles.cell;
                  // Alternate row colors
                  if (R % 2 === 0) {
                     ws[cellRef].s = { ...ws[cellRef].s, ...styles.evenRow };
                  }
               }
            }
         }

         // Merge title cells
         ws['!merges'] = ws['!merges'] || [];
         ws['!merges'].push({
            s: { r: 0, c: 0 },
            e: { r: 0, c: maxColumns - 1 },
         });

         // Merge section title cells
         for (let R = 0; R < allData.length; R++) {
            if (
               allData[R] &&
               allData[R].length === 1 &&
               (allData[R][0] === formatStatusTypeName('onlyReceived') ||
                  allData[R][0] === formatStatusTypeName('partyIssued') ||
                  allData[R][0] === formatStatusTypeName('storeIssued'))
            ) {
               ws['!merges'].push({
                  s: { r: R, c: 0 },
                  e: { r: R, c: maxColumns - 1 },
               });
            }
         }

         // Set column widths
         ws['!cols'] = Array(maxColumns)
            .fill(null)
            .map((_, i) => {
               if (i === 2) return { wch: 30 }; // Item column
               if (i === 3) return { wch: 25 }; // Serial No column
               return { wch: 15 }; // Default width
            });

         // Add worksheet to workbook
         XLSX.utils.book_append_sheet(wb, ws, companyData.companyName.substring(0, 31));
      });

      // Generate Excel file
      const now = new Date();
      const dateStr = `${now.getFullYear()}${(now.getMonth() + 1).toString().padStart(2, '0')}${now
         .getDate()
         .toString()
         .padStart(2, '0')}`;
      XLSX.writeFile(wb, `Party_Stock_Report_${dateStr}.xlsx`);
   };

   const exportToPDF = useCallback(() => {
      if (!allTransaction || allTransaction.length === 0) {
         alert('No data to export');
         return;
      }

      try {
         // Create a new PDF document in landscape mode
         const doc = new jsPDF({
            orientation: 'landscape',
            unit: 'mm',
            format: 'a4',
         });

         // Elegant color palette
         const colors = {
            primary: [30, 41, 59], // Slate
            accent: [79, 70, 229], // Indigo
            text: [15, 23, 42], // Dark slate
            textLight: [100, 116, 139], // Slate gray
            border: [226, 232, 240], // Light slate
            tableBorder: [203, 213, 225], // Slate 300
            headerBg: [248, 250, 252], // Very light slate
            tableHeaderBg: [241, 245, 249], // Light slate bg
         };

         // Helper function to format amounts
         const formatAmount = (amount) => {
            if (amount === null || amount === undefined || amount === '') return '0.00';
            const num = parseFloat(amount);
            if (isNaN(num)) return '0.00';
            return num.toLocaleString('en-IN', {
               minimumFractionDigits: 2,
               maximumFractionDigits: 2,
            });
         };

         // Helper function to format date
         const formatDateForPDF = (dateString) => {
            if (!dateString) return '-';
            try {
               const date = new Date(dateString);
               if (isNaN(date.getTime())) return '-';
               const day = String(date.getDate()).padStart(2, '0');
               const month = String(date.getMonth() + 1).padStart(2, '0');
               const year = date.getFullYear();
               return `${day}-${month}-${year}`;
            } catch (error) {
               return '-';
            }
         };

         // Function to draw header ONLY on first page
         const drawFirstPageHeader = () => {
            // Title with elegant styling
            doc.setFontSize(22);
            doc.setFont('helvetica', 'bold');
            doc.setTextColor(...colors.primary);
            doc.text('All Transactions Report', 14, 18);

            // Date range with refined look
            const fromDate = formatDateForPDF(datePartyWiseSalesRange?.fromDate || '');
            const toDate = formatDateForPDF(datePartyWiseSalesRange?.toDate || '');

            doc.setFontSize(10);
            doc.setFont('helvetica', 'normal');
            doc.setTextColor(...colors.textLight);
            doc.text(`Period: ${fromDate} to ${toDate}`, 14, 26);

            // Elegant double line separator
            doc.setDrawColor(...colors.border);
            doc.setLineWidth(0.3);
            doc.line(14, 30, doc.internal.pageSize.width - 14, 30);
            doc.setLineWidth(0.8);
            doc.line(14, 31.5, doc.internal.pageSize.width - 14, 31.5);
         };

         // Function to draw minimal header for other pages
         const drawMinimalHeader = (pageNum) => {
            doc.setFontSize(9);
            doc.setFont('helvetica', 'normal');
            doc.setTextColor(...colors.textLight);
            doc.text('All Transactions Report', 14, 10);

            // Thin separator line
            doc.setDrawColor(...colors.border);
            doc.setLineWidth(0.3);
            doc.line(14, 12, doc.internal.pageSize.width - 14, 12);
         };

         // Function to draw footer
         const drawFooter = (pageNum, totalPages) => {
            const pageHeight = doc.internal.pageSize.height;
            const pageWidth = doc.internal.pageSize.width;

            // Elegant separator line
            doc.setDrawColor(...colors.border);
            doc.setLineWidth(0.3);
            doc.line(14, pageHeight - 10, pageWidth - 14, pageHeight - 10);

            // Footer text
            doc.setFontSize(8);
            doc.setFont('helvetica', 'normal');
            doc.setTextColor(...colors.textLight);

            // Generated timestamp
            const now = new Date();
            const generatedAt = now.toLocaleString('en-IN', {
               day: '2-digit',
               month: '2-digit',
               year: 'numeric',
               hour: '2-digit',
               minute: '2-digit',
               hour12: true,
            });
            doc.text(`Generated: ${generatedAt}`, 14, pageHeight - 5);

            // Page number
            doc.text(`${pageNum} of ${totalPages}`, pageWidth - 14, pageHeight - 5, {
               align: 'right',
            });
         };

         let startY = 37;
         let pageNumber = 1;
         let isFirstPage = true;

         // Draw first page header
         drawFirstPageHeader();

         // Process each company's data
         allTransaction.forEach((companyData, companyIndex) => {
            // Check if we need a new page
            if (startY > 175) {
               doc.addPage();
               pageNumber++;
               isFirstPage = false;
               drawMinimalHeader(pageNumber);
               startY = 18;
            }

            // Company name header - elegant box
            doc.setFillColor(...colors.headerBg);
            doc.rect(14, startY - 4.5, doc.internal.pageSize.width - 28, 9, 'F');

            // Left border accent
            doc.setFillColor(...colors.accent);
            doc.rect(14, startY - 4.5, 2, 9, 'F');

            doc.setFontSize(11);
            doc.setFont('helvetica', 'bold');
            doc.setTextColor(...colors.primary);
            doc.text(companyData.companyName, 19, startY + 1);

            startY += 11;

            const result = companyData.result || {};

            const statusTypeOrder = [
               'transactionTypeSummary',
               'dailySummary',
               'salesTransactions',
               'salesReturnTransactions',
               'purchasesTransactions',
               'purchaseReturnTransactions',
               'issueTransactions',
               'receiveTransactions',
               'cashReceiveTransactions',
               'cashPaymentTransactions',
               'bankReceiveTransactions',
               'bankPaymentTransactions',
               'journalVoucherTransactions',
            ];

            // Process each status type
            statusTypeOrder.forEach((statusType) => {
               const data = result[statusType];
               if (!data || !Array.isArray(data) || data.length === 0) return;

               if (startY > 165) {
                  doc.addPage();
                  pageNumber++;
                  isFirstPage = false;
                  drawMinimalHeader(pageNumber);
                  startY = 18;
               }

               // Section title - clean and elegant
               doc.setFontSize(10);
               doc.setFont('helvetica', 'bold');
               doc.setTextColor(...colors.text);
               doc.text(formatStatusTypeName(statusType), 14, startY);

               startY += 5;

               // Define columns based on status type
               let columns = [];
               let columnStyles = {};

               if (statusType === 'transactionTypeSummary') {
                  columns = [
                     { header: 'Transaction Type', dataKey: 'transactionType', width: 40 },
                     { header: 'First Transaction', dataKey: 'firstTransaction', width: 25 },
                     { header: 'Last Transaction', dataKey: 'lastTransaction', width: 25 },
                     { header: 'Total Amount', dataKey: 'totalAmount', width: 30 },
                     { header: 'Total Balance', dataKey: 'totalBalance', width: 30 },
                     { header: 'Total Paid', dataKey: 'totalPaid', width: 30 },
                  ];
                  columnStyles = {
                     3: { halign: 'right', cellPadding: { right: 5 } },
                     4: { halign: 'right', cellPadding: { right: 5 } },
                     5: { halign: 'right', cellPadding: { right: 5 } },
                  };
               } else if (statusType === 'dailySummary') {
                  columns = [
                     { header: 'Date', dataKey: 'date', width: 25 },
                     { header: 'Count', dataKey: 'count', width: 15 },
                     { header: 'Transaction Type', dataKey: 'transactionType', width: 35 },
                     { header: 'Total Amount', dataKey: 'totalAmount', width: 30 },
                     { header: 'Balance Amount', dataKey: 'balanceAmount', width: 30 },
                     { header: 'Paid Amount', dataKey: 'paidAmount', width: 30 },
                  ];
                  columnStyles = {
                     3: { halign: 'right', cellPadding: { right: 5 } },
                     4: { halign: 'right', cellPadding: { right: 5 } },
                     5: { halign: 'right', cellPadding: { right: 5 } },
                  };
               } else if (
                  statusType === 'cashReceiveTransactions' ||
                  statusType === 'cashPaymentTransactions' ||
                  statusType === 'bankReceiveTransactions' ||
                  statusType === 'bankPaymentTransactions' ||
                  statusType === 'journalVoucherTransactions'
               ) {
                  columns = [
                     { header: 'Doc No', dataKey: 'docNo', width: 20 },
                     { header: 'Date', dataKey: 'transactionDate', width: 25 },
                     { header: 'Account', dataKey: 'accountName', width: 40 },
                     { header: 'Daybook', dataKey: 'daybookName', width: 30 },
                     { header: 'Total Amount', dataKey: 'totalAmount', width: 30 },
                     { header: 'Balance Amount', dataKey: 'balanceAmount', width: 30 },
                     { header: 'Paid Amount', dataKey: 'paidAmount', width: 30 },
                  ];
                  columnStyles = {
                     4: { halign: 'right', cellPadding: { right: 5 } },
                     5: { halign: 'right', cellPadding: { right: 5 } },
                     6: { halign: 'right', cellPadding: { right: 5 } },
                  };
               } else {
                  columns = [
                     { header: 'Doc No', dataKey: 'docNo', width: 20 },
                     { header: 'Date', dataKey: 'transactionDate', width: 25 },
                     { header: 'Account', dataKey: 'accountName', width: 35 },
                     { header: 'Daybook', dataKey: 'daybookName', width: 30 },
                     { header: 'Total Amount', dataKey: 'totalAmount', width: 30 },
                     { header: 'Balance Amount', dataKey: 'balanceAmount', width: 30 },
                     { header: 'Paid Amount', dataKey: 'paidAmount', width: 30 },
                  ];
                  columnStyles = {
                     4: { halign: 'right', cellPadding: { right: 5 } },
                     5: { halign: 'right', cellPadding: { right: 5 } },
                     6: { halign: 'right', cellPadding: { right: 5 } },
                  };
               }

               // Prepare table data
               const tableData = data.map((item) => {
                  const row = {};

                  if (statusType === 'transactionTypeSummary') {
                     row.transactionType = item.transactionType || '-';
                     row.firstTransaction = formatDateForPDF(item.firstTransaction);
                     row.lastTransaction = formatDateForPDF(item.lastTransaction);
                     row.totalAmount = formatAmount(item.totalAmount);
                     row.totalBalance = formatAmount(item.totalBalance);
                     row.totalPaid = formatAmount(item.totalPaid);
                  } else if (statusType === 'dailySummary') {
                     row.date = formatDateForPDF(item.date);
                     row.count = item.count || '0';
                     row.transactionType = item.transactionType || '-';
                     row.totalAmount = formatAmount(item.totalAmount);
                     row.balanceAmount = formatAmount(item.balanceAmount);
                     row.paidAmount = formatAmount(item.paidAmount);
                  } else {
                     row.docNo = `${item.prifix || ''}${item.docNo || ''}${item.postFix || ''}`
                     row.transactionDate = formatDateForPDF(item.transactionDate);
                     row.accountName = item.accountName || '-';
                     row.daybookName = item.daybookName || '-';
                     row.totalAmount = formatAmount(item.totalAmount);
                     row.balanceAmount = formatAmount(item.balanceAmount);
                     row.paidAmount = formatAmount(item.paidAmount);
                  }

                  return row;
               });

               // Add table with refined styling
               doc.autoTable({
                  columns: columns,
                  body: tableData,
                  startY: startY,
                  margin: { left: 14, right: 14, top: 5, bottom: 20 },
                  headStyles: {
                     fillColor: colors.tableHeaderBg,
                     textColor: colors.primary,
                     fontStyle: 'bold',
                     fontSize: 9,
                     cellPadding: 3.5,
                     lineWidth: 0,
                  },
                  bodyStyles: {
                     fontSize: 8.5,
                     cellPadding: 3,
                     textColor: colors.text,
                     overflow: 'linebreak',
                     valign: 'middle',
                     lineWidth: 0,
                  },
                  alternateRowStyles: {
                     fillColor: [253, 253, 254],
                  },
                  styles: {
                     font: 'helvetica',
                     lineWidth: 0.1,
                     lineColor: colors.tableBorder,
                  },
                  columnStyles: columnStyles,
                  didDrawPage: (data) => {
                     if (data.pageNumber > pageNumber) {
                        pageNumber = data.pageNumber;
                        isFirstPage = false;
                        drawMinimalHeader(pageNumber);
                     }
                  },
                  willDrawCell: (data) => {
                     // Handle header alignment for amount columns
                     if (data.section === 'head') {
                        const columnIndex = data.column.index;
                        const amountColumns =
                           statusType === 'transactionTypeSummary'
                              ? [3, 4, 5]
                              : statusType === 'dailySummary'
                                 ? [3, 4, 5]
                                 : [4, 5, 6];

                        if (amountColumns.includes(columnIndex)) {
                           // Set alignment for amount columns
                           data.cell.styles.halign = 'right';
                        } else {
                           // Set alignment for other columns
                           data.cell.styles.halign = 'left';
                        }
                     }
                  },
                  didDrawCell: (data) => {
                     // Add subtle border under header
                     if (data.section === 'head') {
                        doc.setDrawColor(...colors.tableBorder);
                        doc.setLineWidth(0.5);
                        doc.line(
                           data.cell.x,
                           data.cell.y + data.cell.height,
                           data.cell.x + data.cell.width,
                           data.cell.y + data.cell.height,
                        );
                     }
                  },
               });

               startY = doc.lastAutoTable.finalY + 7;
            });

            // Company separator - refined
            if (companyIndex < allTransaction.length - 1 && startY < doc.internal.pageSize.height - 25) {
               doc.setDrawColor(...colors.border);
               doc.setLineWidth(0.2);
               doc.line(14, startY + 2, doc.internal.pageSize.width - 14, startY + 2);
               startY += 10;
            }
         });

         // Add footers to all pages
         const totalPages = doc.internal.getNumberOfPages();
         for (let i = 1; i <= totalPages; i++) {
            doc.setPage(i);
            drawFooter(i, totalPages);
         }

         // Generate filename
         const now = new Date();
         const dateStr = `${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now
            .getDate()
            .toString()
            .padStart(2, '0')}`;
         const safeFileName = `All_Transactions_Report_${dateStr}.pdf`;

         // Save the PDF
         doc.save(safeFileName);
      } catch (error) {
         console.error('Error exporting to PDF:', error);
         alert('Failed to export PDF file. Please try again.');
      }
   }, [allTransaction, datePartyWiseSalesRange, formatStatusTypeName]);

   const renderStockReport = useMemo(() => {
      if (isLoading) {
         return (
            <Tr>
               <Td colSpan={table.getVisibleFlatColumns().length} textAlign="center" py="100px">
                  <Spinner size="xl" thickness="4px" speed="0.65s" color="blue.500" />
               </Td>
            </Tr>
         );
      }

      if (!allTransaction || allTransaction.length === 0) {
         return (
            <Box textAlign="center" py={10}>
               <Flex direction="column" align="center" justify="center">
                  <img src={nodata} alt="No Data Found" width="200px" height="200px" />
                  <Text mt={4} color={textColor}>
                     No stock data found
                  </Text>
               </Flex>
            </Box>
         );
      }

      const grandTotals = calculateGrandTotals();

      return (
         <>
            {/* Grand Total Header - Show only when multiple companies are selected */}
            {grandTotals && <GrandTotalHeader grandTotals={grandTotals} formatAmount={formatAmount} />}

            {/* Company-wise Data */}
            {allTransaction?.map((companyData) => {
               const result = companyData.result;
               const statusTypes = Object.keys(result).filter(
                  (key) => key !== 'companyId' && result[key] && result[key].length > 0,
               );

               const desiredStatusTypesOrder = [
                  'purchasesTransactions',
                  'purchaseReturnTransactions',
                  'salesTransactions',
                  'salesReturnTransactions',
                  'receiveTransactions',
                  'issueTransactions',
                  'cashReceiveTransactions',
                  'cashPaymentTransactions',
                  'bankReceiveTransactions',
                  'bankPaymentTransactions',
                  'journalVoucherTransactions',
                  'transactionTypeSummary',
                  'dailySummary',
               ];

               const filteredStatusTypes = desiredStatusTypesOrder.filter((type) => statusTypes.includes(type));

               return (
                  <Box key={companyData.companyId} mb={8}>
                     <div className="text-xl font-bold bg-rose-100 text-rose-700 pl-2 rounded-lg py-2 border-l-4 border-rose-700">
                        {companyData.companyName}
                     </div>

                     {filteredStatusTypes.map((statusType) => (
                        <MemoizedStatusSection
                           key={`${companyData.companyId}-${statusType}`}
                           statusType={statusType}
                           data={companyData.result[statusType]}
                           formatStatusTypeName={formatStatusTypeName}
                           formatDateToDDMMYYYY={formatDateToDDMMYYYY}
                           isExpanded={expandedSections[statusType] || false}
                           onToggleExpand={toggleSection}
                           setEntityType={setEntityType}
                           setIsOpenSingleViewinr={setIsOpenSingleViewinr}
                           setIsOpenPurchaseReturnSingleView={setIsOpenPurchaseReturnSingleView}
                        />
                     ))}
                  </Box>
               );
            })}
         </>
      );
   }, [
      isLoading,
      allTransaction,
      table,
      formatStatusTypeName,
      formatDateToDDMMYYYY,
      expandedSections,
      toggleSection,
      isDarkMode,
      textColor,
      calculateGrandTotals,
      formatAmount,
   ]);

   const deletePurchaseReturn = () => {
      const selectedDaybook = daybookData.find((db) => db.id === viewDetail?.daybookId);
      if (entityType === 'purchasereturn') {
         if (selectedDaybook && selectedDaybook?.askPasswordOnDelete) {
            setDataId(viewDetail?.id);
            setIsModalOpen(true);
         } else {
            deleteRecord(
               viewDetail?.id,
               deletePurchaseReturnInvoice,
               dispatch,
               user?.loginhistory?.companyId,
               userGlobalSettingsData,
            );
         }
         // deleteRecord(viewDetail?.id, deletePurchaseReturnInvoice, dispatch, user?.loginhistory?.companyId, userGlobalSettingsData);
      }
      if (entityType === 'salereturn') {
         if (selectedDaybook && selectedDaybook?.askPasswordOnDelete) {
            setDataId(viewDetail?.id);
            setIsModalOpen(true);
         } else {
            deleteRecord(
               viewDetail?.id,
               deleteSaleReturnInvoice,
               dispatch,
               user?.loginhistory?.companyId,
               userGlobalSettingsData,
            );
         }
         // deleteRecord(viewDetail?.id, deleteSaleReturnInvoice, dispatch, user?.loginhistory?.companyId, userGlobalSettingsData);
      }
      if (entityType === 'saleinvoice') {
         if (selectedDaybook && selectedDaybook?.askPasswordOnDelete) {
            setDataId({ id: viewDetail?.id, daybookId: viewDetail.daybookId, accountId: viewDetail.accountId });
            setIsModalOpen(true);
         } else {
            deleteRecordForSales(
               viewDetail?.id,
               viewDetail?.daybookId,
               viewDetail?.accountId,
               deleteSaleInvoice,
               dispatch,
               storedCompanyId,
               userGlobalSettingsData,
            );
         }
         // deleteRecordForSales(
         //    viewDetail?.id,
         //    viewDetail?.daybookId,
         //    viewDetail?.accountId,
         //    deleteSaleInvoice,
         //    dispatch,
         //    storedCompanyId,
         //    userGlobalSettingsData,
         // );
      }
      if (entityType === 'purchaseinvoice') {
         // deleteRecordForSales(
         //    viewDetail?.id,
         //    viewDetail?.daybookId,
         //    viewDetail?.accountId,
         //    deletePurchaseInvoice,
         //    dispatch,
         //    storedCompanyId,
         //    userGlobalSettingsData,
         // );
         if (selectedDaybook && selectedDaybook?.askPasswordOnDelete) {
            setDataId({ id: viewDetail?.id, daybookId: viewDetail.daybookId, accountId: viewDetail.accountId });
            setIsModalOpen(true);
         } else {
            deleteRecordForSales(
               viewDetail?.id,
               viewDetail.daybookId,
               viewDetail.accountId,
               deletePurchaseInvoice,
               dispatch,
               user?.loginhistory?.companyId,
               userGlobalSettingsData,
            );
         }
      }
      setIsOpenPurchaseReturnSingleView(false);
   };

   const handleSalesDetailsClose = () => {
      setIsOpenPurchaseReturnSingleView();
   };

   useEffect(() => {
      if (account) {
         const details = [
            { label: 'Bill To', value: account?.name || '-' },
            { label: 'Mobile', value: account?.mobile || '-' },
            { label: 'PAN', value: account?.panNo || '-' },
            { label: 'Billing Address', value: account?.address || '-' },
         ];
         setDynamicUserDetails(details);
      }
   }, [account]);

   const handleShowHideFormOpen = async () => {
      setIsShowHideColumn(true);
      const formatData = reportformat.find((f) => f.title === stockTypeSelected);
      if (formatData) {
         setIsEditShowHide(true);
         setEditData(formatData);
      } else {
         setIsEditShowHide(false);
         setEditData({});
      }
   };

   const handleSave = async () => { };

   const startEditing = async (id, rowData) => {
      await dispatch(
         getDaybookForPayments({
            type: isBankPageTrue ? 14 : 13,
            companyId: user?.loginhistory?.companyId,
            ...(shouldSendIdInDaybook && { companyIds: user?.loginhistory?.companyId }),
         }),
      );
      await dispatch(
         getAccount({
            compId: user?.loginhistory?.companyId,
            status: true,
            ...(shouldSendIdInAccount && { companyIds: user?.loginhistory?.companyId }),
         }),
      );
      const selectAcc = accountData.filter((acc) => acc.id === rowData.accountId);
      setSelectedEditAccount(selectAcc[0]);
      setFormData((prev) => ({
         ...prev,
         id,
         ...rowData,
      }));
      setIsOutstandingModalOpen(true);
      setUpdateFormLoading(true);
   };

   const handleClearData = () => {
      setPendingVoucher([]);
      setFormData({
         companyId: parseInt(localStorage.getItem('companyId')),
         txnDate: new Date().toISOString().split('T')[0],
         daybookId: daybookTypeData?.length === 1 ? daybookTypeData[0].id : '',
         docNumber: 0,
         txnType: `${transactionTypem === 'payment' ? 1 : 0}`,
         accountId: null,
         amount: receivedAmount,
         brokerId: null,
         supplierId: 0,
         chequeNo: 0,
         transactionNo: 0,
         bankId: 0,
         bankBranchId: 0,
         particulars: '',
         depositeDate: '',
         clearingDate: '',
         tdsApplicable: false,
         tdsAccountId: 0,
         tdsLimit: 0,
         tdsRate: 0,
         tdsCess: 0,
         tdsSurcharge: 0,
         tdsAmount: 0,
         tdsCessAmount: 0,
         tdsSurchargeAmount: 0,
         tdsHCessAmount: 0,
         tdsInterestAmount: 0,
         tdsPenaltyAmount: 0,
         tdsOthersAmount: 0,
         notes1: '',
         notes2: '',
         notes3: '',
         notes4: '',
         notes5: '',
         userNote: '',
         taxableValue: '',
         GSTAmount: 0,
         stateOfSupply: 0,
         isRCM: false,
         GSTSubTxnType: 0,
         HSNSACId: 0,
         typeofSupply: 0,
         partyBillNo: 0,
         GSTTxnType: 0,
         outAdjustments: [],
      });
      setReceivedAmount(0);
      setTotalPendingAccount(0);
   };

   return (
      <>
         <Flex pr="25px" mb="5px" justifyContent="space-between" align="center" mt="50px" overflow={'hidden'}>
            <Flex>
               <img
                  src={back}
                  alt="Go Back"
                  width="15px"
                  onClick={() => window.history.back()}
                  style={{ cursor: 'pointer' }}
               />
               <Text color={textColor} fontSize="15px" fontWeight="700" lineHeight="100%" ml={5}>
                  All Transaction
               </Text>
            </Flex>
            <Flex gap={2}>
               <Button size="sm" variant="outline" onClick={expandAll} leftIcon={<MdExpand />}>
                  Expand All
               </Button>
               <Button size="sm" variant="outline" onClick={collapseAll} leftIcon={<MdCompress />}>
                  Collapse All
               </Button>
            </Flex>
         </Flex>

         <Box mt="15px" bg={backgroundColor} px={4} py={0} borderRadius="7px">
            <Flex className="flex flex-wrap gap-2" alignItems="center" justifyContent={{ base: 'end' }}>
               <Flex flex="1" gap={2} mr={3} display={{ base: 'none', xl: 'flex' }}>
                  <div flex="1" mr={''} justifyContent="center">
                     <Box
                        my={2}
                        width="300px"
                        fontSize={'13px'}
                        mt={5}
                        fontWeight={500}
                        display={{ base: 'none', xl: 'block' }}>
                        <GridItem className="seperator-width">
                           {renderDynamicDropdown(
                              'company',
                              'Company',
                              lastcompanyOptions,
                              {
                                 value: companyFilter,
                                 onChange: handleCompanyChange,
                              },
                              {},
                              textColor,
                              false,
                              'Select company',
                              true,
                              undefined,
                              true,
                           )}
                        </GridItem>
                     </Box>
                  </div>
               </Flex>

               <Flex flex="" display={{ base: 'none', xl: 'flex' }} mr={3}>
                  <Box my={2} width="170px" fontSize="13px" fontWeight={500}>
                     <label>Transaction Type</label>
                     <Select
                        placeholder="Select Stock-Status"
                        name="Stock-Status"
                        options={transactionType.map((comp) => ({ value: comp.id, label: comp.name }))}
                        value={stockTypeSelected}
                        onChange={setStockTypeSelected}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        styles={{
                           control: (baseStyles, state) => ({
                              ...baseStyles,
                              minHeight: '30px',
                              height: '30px',
                              backgroundColor: controlBg,
                              borderColor: controlBorder,
                              boxShadow: state.isFocused ? focusBoxShadow : baseStyles.boxShadow,
                              '&:hover': {
                                 borderColor: controlBorderHover,
                              },
                           }),
                           valueContainer: (baseStyles) => ({
                              ...baseStyles,
                              height: '30px',
                              padding: '0 6px',
                              color: textColor,
                           }),
                           indicatorsContainer: (baseStyles) => ({
                              ...baseStyles,
                              height: '30px',
                           }),
                           singleValue: (baseStyles) => ({
                              ...baseStyles,
                              color: textColor,
                           }),
                           placeholder: (baseStyles) => ({
                              ...baseStyles,
                              color: placeholderColor,
                           }),
                           option: (baseStyles, state) => ({
                              ...baseStyles,
                              backgroundColor: state.isFocused ? optionHoverBg : optionBg,
                              color: textColor,
                              '&:hover': {
                                 backgroundColor: optionHoverBg,
                              },
                           }),
                           menu: (baseStyles) => ({
                              ...baseStyles,
                              backgroundColor: menuBg,
                              border: `1px solid ${menuBorder}`,
                           }),
                           dropdownIndicator: (baseStyles) => ({
                              ...baseStyles,
                              color: indicatorColor,
                              '&:hover': {
                                 color: indicatorHoverColor,
                              },
                           }),
                           clearIndicator: (baseStyles) => ({
                              ...baseStyles,
                              color: indicatorColor,
                              '&:hover': {
                                 color: indicatorHoverColor,
                              },
                           }),
                        }}
                     />
                  </Box>
               </Flex>

               <Flex flex="2" display={{ base: 'none', xl: 'flex' }}>
                  <Flex alignItems={'center'} mt={3}>
                     <PeriodDatePicker
                        value={
                           datePartyWiseSalesRange?.fromDate && datePartyWiseSalesRange?.toDate
                              ? [new Date(datePartyWiseSalesRange.fromDate), new Date(datePartyWiseSalesRange.toDate)]
                              : null
                        }
                        onChange={handleDateRangeChange}
                        defaultPeriod="today"
                        style={{ width: 250, marginRight: 20, borderRadius: 5, height: 35 }}
                     />
                  </Flex>
               </Flex>

               <Flex flex="1"></Flex>

               <Flex>
                  <Box flex="1" mr={3}>
                     <MotionFlex
                        ref={wrapperRef}
                        align="center"
                        bg={bg}
                        borderRadius="full"
                        cursor="pointer"
                        px={expanded ? 3 : 0}
                        w={expanded ? '250px' : '40px'}
                        h="40px"
                        transition="all 0.3s ease"
                        onClick={() => setExpanded(true)}>
                        <MotionSearchIcon
                           color={icon}
                           animate={{ rotate: expanded ? 0 : 90 }}
                           transition={{ duration: 0.3 }}
                           style={{
                              marginRight: expanded ? '8px' : '10px',
                              marginLeft: expanded ? '0' : '10px',
                           }}
                        />
                        {expanded && (
                           <Input
                              variant="unstyled"
                              placeholder="Search accounts..."
                              value={searchQuery}
                              onChange={handleSearchChange}
                              color={icon}
                              flex="1"
                           />
                        )}
                     </MotionFlex>
                  </Box>

                  <Button onClick={handleRefresh} _hover={{ bg: 'blue.50' }} mr={2}>
                     <HiOutlineRefresh size={20} mr={2} />
                  </Button>

                  <Button cursor={'pointer'} onClick={onFilterOpen} mr={2}>
                     <IoFilterOutline size={22} />
                  </Button>

                  <Popover>
                     <PopoverTrigger>
                        <img src={Download} alt="Download" width="30" style={{ cursor: 'pointer' }} />
                     </PopoverTrigger>
                     <PopoverContent width="220px" zIndex="10" bg={backgroundColor} mr={8}>
                        <PopoverBody p="3">
                           <Button
                              width="100%"
                              variant="ghost"
                              _hover={{ bg: 'blue.100' }}
                              onClick={exportToExcel}
                              justifyContent="space-between"
                              mb={3}>
                              <img src={xls} alt="Download XLS" width="30px"></img>
                              Download Excel
                           </Button>
                           <Button
                              width="100%"
                              variant="ghost"
                              _hover={{ bg: 'blue.100' }}
                              onClick={exportToPDF}
                              justifyContent="space-between">
                              <img src={xls} alt="Download pdf" width="30px" mr></img>
                              Download Pdf
                           </Button>
                        </PopoverBody>
                     </PopoverContent>
                  </Popover>
               </Flex>
            </Flex>
         </Box>

         <Grid overflow="auto">
            <Card mt="15px" borderRadius="7px">
               <Box
                  overflowX="auto"
                  className="custom-scrollbar"
                  position="relative"
                  minH={{ base: '75vh', md: '75vh', xl: '75vh' }}
                  maxH={{ base: '75vh', md: '75vh', xl: '75vh' }}>
                  {isFilterLoading && (
                     <Box
                        position="fixed"
                        top={0} left={0} right={0} bottom={0}
                        zIndex={9999}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        bg={isDarkMode ? 'rgba(10,20,50,0.60)' : 'rgba(255,255,255,0.60)'}
                        backdropFilter="blur(3px)"
                     >
                        <Flex direction="column" align="center" gap={3}>
                           <Spinner size="xl" thickness="4px" speed="0.65s" color="blue.500" />
                        </Flex>
                     </Box>
                  )}
                  <Table variant="simple" color="gray.500" mb="24px" mt="12px">
                     <Tbody>{renderStockReport}</Tbody>
                  </Table>
               </Box>
            </Card>
         </Grid >

         <SalesPurchaseFilter
            isOpen={isFilterOpen}
            onClose={onFilterClose}
            companyIds={companyIds}
            fromDate={datePartyWiseSalesRange.fromDate}
            toDate={datePartyWiseSalesRange.toDate}
            type={stockTypeSelected?.value}
            entityType={'allTransaction'}
            onApply={() => setIsFilterLoading(true)}
         />
         <SalesDetails
            isOpen={isOpenPurchaseReturnSingleView}
            onClose={handleSalesDetailsClose}
            singleEntityRights={
               saleInvoiceRight ||
               saleReturnRight ||
               purchaseInvoiceRight ||
               purchaseReturnRight ||
               IssueRight ||
               ReceiveRight
            }
            title={
               entityType === 'saleinvoice'
                  ? 'Sales Invoice'
                  : entityType === 'salereturn'
                     ? 'Sales Return'
                     : entityType === 'purchaseinvoice'
                        ? 'Purchase Invoice'
                        : entityType === 'purchasereturn'
                           ? 'Purchase Return'
                           : entityType === 'issueinventory'
                              ? 'Issue'
                              : entityType === 'receiveinventory'
                                 ? 'Receive'
                                 : null
            }
            entityType={entityType}
            singleEntity={viewDetail}
            setIsEditFormOpen={setIsEditFormOpen}
            handlePrevPage={handlePrevPage}
            handleNextPage={handleNextPage}
            setIsOpenSingleView={setIsOpenPurchaseReturnSingleView}
            isEditFormOpen={isEditFormOpen}
            viewDetail={viewDetail}
            lineItems={viewDetail?.lineitems}
            billTerms={viewDetail?.purchasereturnbillteams || viewDetail?.receiveBillTerms}
            onDelete={deletePurchaseReturn}
            handleSerchClose={() => {
               console.log('');
            }}
         />

         <ColumnShowHide
            isOpen={isShowHideColumn}
            onClose={() => setIsShowHideColumn(false)}
            data={columnsData}
            setShowHideData={setShowHideData}
            isedit={isEditShowHide}
            editData={editData}
            // selectedFormat={storeStockTypeOptions.dynamicOptions}
            // FixdefName1={'SalesDetailDate'}
            // FixdefName2={'SalesDetailParty'}
            // FixdefName3={'SalesDetailBroker'}
            // staticOption={staticOption}
            dynamicEditOption={dynamicEditOption}
         />

         {
            updateFormLoading && formData.id && (
               <PaymentcaseFormEdit
                  isOutstandingModalOpen={isOutstandingModalOpen}
                  setIsOutstandingModalOpen={setIsOutstandingModalOpen}
                  daybookTypeData={daybookTypeData}
                  validationSchema={validationSchema}
                  errors={errors}
                  setErrors={setErrors}
                  selectedAccount={selectedEditAccount}
                  setSelectedAccount={setSelectedEditAccount}
                  userData={accountData}
                  type={13}
                  isEditMode={true}
                  receivedAmount={receivedAmount}
                  setReceivedAmount={setReceivedAmount}
                  totalPendingAccount={totalPendingAccount}
                  setTotalPendingAccount={setTotalPendingAccount}
                  formData={formData}
                  setFormData={setFormData}
                  transactionType={transactionTypem}
                  handleClearData={handleClearData}
                  pendingVoucher={pendingVoucher}
                  setPendingVoucher={setPendingVoucher}
                  currentPage={1}
                  limit={10}
                  companyId={companyId}
                  sorting={sorting}
                  pagination={10}
               />
            )
         }

         <ViewSingleCashBankData
            isOpenSingleView={isOpenSingleViewcnb}
            onClose={() => setIsOpenSingleViewcnb(false)}
            singleEntity={singleEntity}
            formType="voucher"
            isBankPageTrue={isBankPageTrue}
            UserRights={(cashPaymentRight && cashReceiveRight) || (bankPaymentRight && bankReceiveRight)}
            paymentRight={cashPaymentRight || bankPaymentRight}
            receiveRight={cashReceiveRight || bankReceiveRight}
            startEditing={(data) => startEditing(data.id, data)}
         />

         <JournalVoucherForm
            isOpen={isOpenJV}
            onClose={() => setisOpenJV(false)}
            isEditMode={isEditMode}
            currentRow={currentRow}
            onSave={handleSave}
         />

         <DeletePasswordModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            onConfirm={
               entityType === 'saleinvoice' || entityType === 'purchaseinvoice' ? deleteRecordForSales : deleteRecord
            }
            id={dataId}
            deleteApi={
               entityType === 'saleinvoice'
                  ? deleteSaleInvoice
                  : entityType === 'purchaseinvoice'
                     ? deletePurchaseInvoice
                     : entityType === 'salereturn'
                        ? deleteSaleReturnInvoice
                        : deletePurchaseReturnInvoice
            }
            dispatch={dispatch}
            type={entityType === 'saleinvoice' || entityType === 'purchaseinvoice' ? 'purchase' : 'receive'}
            userGlobalSettingsData={userGlobalSettingsData}
         />
      </>
   );
};

export default AllTransaction;
